import React, { useEffect, useState } from "react";
import WebIcon from "@mui/icons-material/SpaceDashboardOutlined";
import StoreIcon from "@mui/icons-material/StoreOutlined";
import CalendarIcon from "@mui/icons-material/CalendarMonthOutlined";
import TableIcon from "@mui/icons-material/TableView";
import { Box, Grid } from "@mui/material";
import PropTypes from "prop-types";
import { useLeftBar } from "../../context/LeftBar";
import { Header } from "./components/Header";
import NavItem from "./MenuItem/NavItem";
import { ReactComponent as InsightsTimelineIcon } from "../../assets/icons/insights-timeline.svg";
import { ReactComponent as PositivacaoIcon } from "../../assets/icons/positivacao.svg";
import { ReactComponent as SellIcon } from "../../assets/icons/sell.svg";
import FormulaLogoFooter from "../../assets/img/logo-footer-excellence.png";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import OutlinedFlagIcon from "@mui/icons-material/OutlinedFlag";

function LeftSideMenu({ app, config, logo }) {
  const { leftBarOpened, setLeftBarOpened } = useLeftBar();

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [dataAtualizacao, setDataAtualizacao] = useState("");

  async function initialSelecao() {
    await app.variable.getContent("vAtualizacao", (reply) => {
      const data = reply.qContent.qString;
      setDataAtualizacao(data.substring(0, 15));
    });
  }


  useEffect(() => {
    initialSelecao();
    window.addEventListener("resize", () => setScreenWidth(window.innerWidth));

    return () => {
      window.removeEventListener("resize", () =>
        setScreenWidth(window.innerWidth)
      );
    };
  }, []);


  return (
    <div className={leftBarOpened ? "leftSideMenu is-opened" : "leftSideMenu"}>
      <div className="containerLeftSideMenu">
        <Header leftBarOpened={leftBarOpened} />

        <div className="leftSideClientContainer">
          {leftBarOpened && <h2 className="titleSideCLient">PED 2025</h2>}
        </div>

        <div
          className={
            leftBarOpened
              ? "leftSideContent"
              : "leftSideContent leftSideContent-open"
          }
        >
          <ul>
            <NavItem
              muiIcon={<WebIcon />}
              name="Visão Geral"
              path="/overview"
            />

            <NavItem
              muiIcon={<InsightsTimelineIcon />}
              name="Apuração"
              path="/msl"
            />

            <NavItem
              muiIcon={<SellIcon />}
              name="Sell in x Sell out"
              path="/sell"
            />

            <NavItem
              muiIcon={<PositivacaoIcon />}
              name="Positivação"
              path="/positivacao"
            />

            <NavItem muiIcon={<StoreIcon />} name="Top PDVs" path="/ranking" />

            <NavItem
              muiIcon={<OutlinedFlagIcon />}
              name="Desafios"
              path="/challenge"
            />

            <NavItem
              muiIcon={<CalendarIcon />}
              name="Envio Mtrix"
              path="/send"
            />

            <NavItem muiIcon={<TableIcon />} name="ADM" path="/adm" />
          </ul>
        </div>

        <div
          className={
            leftBarOpened
              ? "leftSideContent leftSideContent-second"
              : "leftSideContent leftSideContent-second leftSideContent-open"
          }
        ></div>

        {leftBarOpened && (
          <Grid
            flexDirection={"column"}
            alignItems={"flex-start"}
            columnGap={1}
            className="leftSideFooter"
          >
            <Grid item>
              <Box
                component={"img"}
                src={FormulaLogoFooter}
                className="container-img-leftSide"
              />
            </Grid>
            <Grid item>
              <span>Atualizado em: {dataAtualizacao} </span>
            </Grid>
          </Grid>
        )}
      </div>

      <div className="containerCloseSideMenu">
        <button
          type="button"
          onClick={() => {
            setLeftBarOpened(!leftBarOpened);
          }}
          className={leftBarOpened ? "" : "align-left"}
        >
          {leftBarOpened ? (
            <ArrowBackIosOutlinedIcon
              fontSize="small"
              sx={{ color: "#04477B" }}
            />
          ) : (
            <ArrowForwardIosOutlinedIcon
              fontSize="small"
              sx={{ color: "#04477B" }}
            />
          )}
        </button>
      </div>
    </div>
  );
}

LeftSideMenu.defaultProps = {
  app: null,
  config: null,
  logo: null,
};

LeftSideMenu.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  logo: PropTypes.object,
};

export default LeftSideMenu;
